import turfCenter from '@turf/center'
import { hexToRGB } from '@krknet/fe/helpers'

export const hexToRGBstring = color => (({ r, g, b }) => `${r}, ${g}, ${b}`)(hexToRGB(color))

export function coordsToDistance (lat1, lng1, lat2, lng2) {
  const degreesToRadians = degrees => degrees * Math.PI / 180
  const earthRadius = 6371

  const dLat = degreesToRadians(lat2 - lat1)
  const dLng = degreesToRadians(lng2 - lng1)

  lat1 = degreesToRadians(lat1)
  lat2 = degreesToRadians(lat2)

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return earthRadius * c
}

export function formatDistance (distance) {
  if (distance >= 10) return distance.toFixed(0) + '<span class="opacity-50 pl-0.5">km</span>'
  if (distance >= 1) return distance.toFixed(1) + '<span class="opacity-50 pl-0.5">km</span>'
  return (distance * 1000).toFixed(0) + '<span class="opacity-50 pl-0.5">m</span>'
}

// https://github.com/d3/d3-array/blob/master/src/extent.js
export function extent (values, valueof) {
  let min
  let max

  if (valueof === undefined) {
    for (const value of values) {
      if (value != null) {
        if (min === undefined) {
          if (value >= value) min = max = value // eslint-disable-line no-self-compare
        } else {
          if (min > value) min = value
          if (max < value) max = value
        }
      }
    }
  } else {
    let index = -1
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null) {
        if (min === undefined) {
          if (value >= value) min = max = value // eslint-disable-line no-self-compare
        } else {
          if (min > value) min = value
          if (max < value) max = value
        }
      }
    }
  }

  return [min, max]
}

export function insidePoly ([x, y], poly) {
  let isInside = false
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const xI = poly[i][0]
    const yI = poly[i][1]
    const xJ = poly[j][0]
    const yJ = poly[j][1]

    const isIntersecting = ((yI > y) !== (yJ > y)) && (x < (xJ - xI) * (y - yI) / (yJ - yI) + xI)
    if (isIntersecting) isInside = !isInside
  }
  return isInside
}

export const unqiueBy = (arr, fn) => [...new Map(arr.map(x => [fn(x), x])).values()]

export {
  clickawayDirective as onClickaway,
  debounce,
  deepFreeze,
  deepGet,
  deepSet,
  focusDirective,
  formatDate,
  formatNum,
  hexToRGB,
  throttle
} from '@krknet/fe/helpers'

export function getFieldCenter ({ coords }) {
  const [lng, lat] = turfCenter({ type: 'Feature', geometry: { type: 'Polygon', coordinates: [coords] } }).geometry.coordinates
  return { lat, lng }
}
